import React, { useContext, useEffect, useState } from "react";
import { Badge, Text, LegacyCard as Card, Checkbox, DataTable, Layout, PageActions, TextField } from "@shopify/polaris";
import { baseHelper, errorHelper } from "lib/helpers";
import { withErrorBoundary, withFeature } from "lib/hoc";
import { PrivateContext } from "lib/context";
import { Toast, Banner, Spinner } from "lib/components";
import constant from "lib/constant/constant";
import { useQuery, useMutation } from "@apollo/client";
import { UPDATE_PRODUCT_EXPORT_SETTING } from "app/setup/apollo/mutations";
import { GET_PRODUCT_EXPORT_SETTING } from "app/setup/apollo/queries";

import { useNavigate } from "react-router-dom";
import ExportTable from "./style";

const { gql } = constant;

const ProductExportSetting = () => {
  const {
    CRITICAL,
    HIDDEN,
    IS_CSV,
    IS_PDF,
    PARTIALLY_HIDDEN,
    PRODUCT_COLUMN,
    PRODUCT_TABLE_HEADING,
    SUCCESS,
    VISIBLE,
    WARNING,
  } = constant;

  const { cms, currentUser } = useContext(PrivateContext);
  const navigate = useNavigate();
  const isVendor = baseHelper.isVendor(currentUser);
  const [submitEnabled, setSubmitEnable] = useState(false);
  const [firstPush, setFirstPush] = useState(true);
  const [checked, setChecked] = useState(false);
  const [message, setMessage] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [bannerStatus, setBannerStatus] = useState({
    title: "",
    status: "",
    isOpen: false,
  });
  // const [userInput, setUserInput] = useState(paymentTableData);

  const [userInput, setUserInput] = useState({
    handle: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    title: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    body: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    vendor: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    type: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    tags: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    collectionData: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    published: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option1Name: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option1Value: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option2Name: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option2Value: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option3Name: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    option3Value: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantSku: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantWeight: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantInventoryTracker: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantInventoryQty: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantInventoryPolicies: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantPrice: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantCompareAtPrice: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantRequiresShipping: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantTaxable: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    variantBarcode: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    imageSrc: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    imageAtText: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
    giftCard: {
      isHideCsv: false,
      isHidePdf: false,
      label: "",
    },
  });

  const [productSetting, { loading: settingUpdateLoading }] = useMutation(UPDATE_PRODUCT_EXPORT_SETTING);
  const {
    error: errorProductExportSetting,
    loading: productExportLoading,
    data: getProductExportSetting,
    refetch,
  } = useQuery(GET_PRODUCT_EXPORT_SETTING);

  useEffect(() => {
    let allChecked = true;
    const newState = { ...userInput };
    const keys = Object.keys(newState);
    keys.forEach((key) => {
      const { isHideCsv, isHidePdf } = newState[key];
      if (!isHideCsv || !isHidePdf) {
        allChecked = false;
      }
    });
    if (allChecked) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [userInput]);

  useEffect(() => {
    if (getProductExportSetting) {
      const productData = baseHelper.getResponseData(getProductExportSetting, gql.GET_PRODUCT_EXPORT_SETTING);
      const productError = baseHelper.getResponseError(errorProductExportSetting, gql.GET_PRODUCT_EXPORT_SETTING);
      const data = productData.export;
      if (data) {
        const keys = Object.keys(userInput);
        keys.forEach((key) => {
          if (!data[key]) {
            data[key] = {
              label: "",
              isHideCsv: false,
              isHidePdf: false,
            };
          }
        });

        if (productData.updatedAt) {
          setUpdatedAt(productData.updatedAt);
          setFirstPush(false);
          setUserInput(data);
        }
        if (productError) {
          setBannerStatus({ isOpen: true, title: productError, status: constant.CRITICAL });
        }
      }
    }
  }, [getProductExportSetting, errorProductExportSetting]);

  useEffect(() => {
    setTimeout(() => {
      setMessage("");
    }, 2000);
  }, [message]);

  const verifyValues = () => {
    setSubmitEnable(false);
    const newData = [];
    const currentLabel = [];
    const noUncheckCsv = Object.keys(userInput).map((item) => {
      newData.push(userInput[item]);
      currentLabel.push(cms(`label.${item}`));
      if (userInput[item].isHideCsv) {
        return true;
      }
      return false;
    });

    const noUncheckPdf = Object.keys(userInput).map((item) => {
      if (userInput[item].isHidePdf) {
        return true;
      }
      return false;
    });

    let response = false;
    newData.forEach((item, i) => {
      newData.forEach((element, index) => {
        if (i === index) return null;
        const found = currentLabel.find((label) => label === element.label);
        if ((element.label && item.label && element.label.trim() === item.label.trim()) || found) {
          response = true;
          setBannerStatus({
            isOpen: true,
            title: cms("message.error.duplicate"),
            status: constant.CRITICAL,
          });
          return false;
        }
        return false;
      });
    });
    if (!response) {
      response = true;
      noUncheckCsv.forEach((item) => {
        if (!item) response = item;
      });
      setBannerStatus({
        isOpen: response,
        title: cms("message.error.uncheckCsv"),
        status: constant.CRITICAL,
      });
    }
    if (!response) {
      response = true;
      noUncheckPdf.forEach((item) => {
        if (!item) response = item;
      });

      setBannerStatus({
        isOpen: response,
        title: cms("message.error.uncheckPdf"),
        status: constant.CRITICAL,
      });
    }
    return response;
  };

  const handleAllChecked = (value) => {
    setSubmitEnable(true);
    setChecked(value);
    const newData = [];
    Object.keys(userInput).map((item) => {
      newData.push(userInput[item]);
    });
    setUserInput((prevState) => {
      const newState = { ...prevState };
      const keys = Object.keys(newState);
      keys.forEach((key, index) => {
        newState[key] = { isHideCsv: value, isHidePdf: value, label: newData[index].label };
      });
      return newState;
    });
  };

  const updateProductSetting = async (type) => {
    productSetting({ variables: { input: { ...userInput } } })
      .then((res) => {
        if (res) {
          const resData = baseHelper.getResponseData(res.data, constant.gql.UPDATE_PRODUCT_EXPORT_SETTING);
          const resError = baseHelper.getResponseError(res.data, constant.gql.UPDATE_PRODUCT_EXPORT_SETTING);
          if (resData) {
            refetch();
            setMessage(cms("message.success.productUpdate"));
          }
          if (!resError && type === constant.SAVE_SMALL) {
            setMessage(cms("message.success.product"));
          }
          if (resError) {
            setBannerStatus({ isOpen: true, title: resError, status: constant.CRITICAL });
          }
        }
      })
      .catch((exception) => {
        setBannerStatus({ isOpen: true, title: errorHelper.parse(exception), status: constant.CRITICAL });
      });
  };
  const dismissBanner = () => setBannerStatus({ isOpen: false, status: "", title: "" });

  const handleLabelChange = (val, key) => {
    const labelRegex = /[^a-zA-Z ]/;
    const updatedData = JSON.parse(JSON.stringify(userInput));
    const newData = updatedData[key];
    newData.label = val.split(labelRegex).join("");
    setUserInput({ ...updatedData, [key]: newData });
    setSubmitEnable(true);
  };

  const selectCurrentLabelsColumn = (item) => <Text as="span">{cms(`label.${item}`) || item}</Text>;
  const selectNewLabelsTextField = (data, key) => (
    <>
      <TextField value={data && data.label} maxLength={35} onChange={(value) => handleLabelChange(value, key)} />
    </>
  );

  const handleCheckbox = (value, key) => {
    const updateData = userInput[key];
    setSubmitEnable(true);
    if (value === IS_CSV) setUserInput({ ...userInput, [key]: { ...updateData, isHideCsv: !updateData.isHideCsv } });
    if (value === IS_PDF) setUserInput({ ...userInput, [key]: { ...updateData, isHidePdf: !updateData.isHidePdf } });
  };

  const badges = (item) => (
    <>
      <Badge tone={item.badgesStatus}>{item.badgesLable}</Badge>
    </>
  );
  const selectHideColumn = (index) => (
    <>
      <Checkbox
        label={cms("label.isCsv")}
        checked={userInput[index] && userInput[index].isHideCsv}
        // onChange={(value) => handleCheckbox("isCsv", value, index)}
        onChange={() => handleCheckbox(IS_CSV, index)}
      />{" "}
      <Checkbox
        label={cms("label.isPdf")}
        checked={userInput[index] && userInput[index].isHidePdf}
        onChange={() => handleCheckbox(IS_PDF, index)}
      />
    </>
  );

  const getRows = () => {
    return Object.keys(userInput).map((item) => {
      let badge = { badgesLable: VISIBLE, badgesStatus: SUCCESS };
      const itemData = userInput[item];
      if (itemData.isHideCsv && itemData.isHidePdf) {
        badge = { badgesLable: HIDDEN, badgesStatus: CRITICAL };
      } else if (itemData.isHidePdf || itemData.isHideCsv) {
        badge = { badgesLable: PARTIALLY_HIDDEN, badgesStatus: WARNING };
      } else {
        badge = { badgesLable: VISIBLE, badgesStatus: SUCCESS };
      }
      const currentValues = selectCurrentLabelsColumn(item);
      const newValues = selectNewLabelsTextField(userInput[item], item);
      const badgesValues = badges(badge);
      const hideColumnValues = selectHideColumn(item);
      return [[currentValues], [newValues], [hideColumnValues], [badgesValues]];
    });
  };

  if (productExportLoading) {
    return <Spinner />;
  }

  return (
    <Layout>
      <Layout.Section>
        {bannerStatus.isOpen && (
          <Layout.Section>
            <Banner
              isOpen={bannerStatus.isOpen}
              status={bannerStatus.status}
              title={bannerStatus.title}
              onDismiss={() => dismissBanner()}
            />
          </Layout.Section>
        )}
        <Layout.AnnotatedSection title={cms("title")} description={cms("description")}>
          <Card>
            <Card.Header
              title={[
                cms("label.exportSetting"),
                updatedAt && (
                  <Text as="span" tone="subdued">
                    <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
                  </Text>
                ),
              ]}
            >
              <Checkbox label={cms("label.markAll")} checked={checked} onChange={(value) => handleAllChecked(value)} />
            </Card.Header>
            <Card.Section>
              <ExportTable className="payment-export-table">
                <DataTable columnContentTypes={PRODUCT_COLUMN} headings={PRODUCT_TABLE_HEADING} rows={getRows()} />
              </ExportTable>
              {!firstPush && (
                <PageActions
                  primaryAction={{
                    content: cms("common.button.update"),
                    onAction: () => {
                      const update = verifyValues();
                      if (!update) updateProductSetting();
                    },
                    disabled: !submitEnabled,
                    loading: settingUpdateLoading,
                  }}
                  secondaryActions={[
                    {
                      id: "cancelButton",
                      content: cms("common.button.cancel"),
                      onAction: () => navigate("/setting"),
                    },
                  ]}
                />
              )}
            </Card.Section>
          </Card>
          {firstPush && (
            <div>
              <PageActions
                primaryAction={{
                  content: cms("common.button.submit"),
                  onAction: () => {
                    const update = verifyValues();
                    if (!update) updateProductSetting(constant.SAVE_SMALL);
                  },
                  disabled: !submitEnabled,
                  loading: settingUpdateLoading,
                }}
                secondaryActions={[
                  {
                    id: "cancelButton",
                    content: cms("common.button.cancel"),
                    onAction: () => navigate("/setting"),
                  },
                ]}
              />
            </div>
          )}
        </Layout.AnnotatedSection>
        <Toast message={message} timeout={5000} />
      </Layout.Section>
    </Layout>
  );
};

export default withFeature(withErrorBoundary(ProductExportSetting), { feature: constant.PRODUCT_EXPORT_SETTING });
